module.exports = __webpack_public_path__ + "static/media/icon-close.af98cff1.svg";